import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : {
        "Content-Type": "application/json",
      };
};

export async function getSurveyContext(token) {
  const res = await axios.get(`${API}/public/surveys/${token}/context`);
  return res.data;
}

export async function submitSurvey(token, payload) {
  const res = await axios.post(`${API}/public/surveys/${token}/submit`, payload, {
    headers: authHeaders(),
  });
  return res.data;
}

export async function listClientSurveys(params, token) {
  const res = await axios.get(`${API}/marketing/client-surveys`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getClientSurveyDetail(requestId, token) {
  const res = await axios.get(`${API}/marketing/client-surveys/${requestId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function resendClientSurvey(requestId, token) {
  const res = await axios.post(
    `${API}/marketing/client-surveys/${requestId}/resend`,
    {},
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function createSurveyFollowup(requestId, token) {
  const res = await axios.post(
    `${API}/marketing/client-surveys/${requestId}/followup`,
    {},
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function getSurveyConfig(salonId, token) {
  const res = await axios.get(`${API}/marketing/surveys/config`, {
    params: { salon_id: salonId },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createSurveyConfig(salonId, payload, token) {
  const res = await axios.post(`${API}/marketing/surveys/config`, payload, {
    params: { salon_id: salonId },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function activateSurveyConfig(salonId, configId, token) {
  const res = await axios.put(
    `${API}/marketing/surveys/config/${configId}/activate`,
    {},
    {
      params: { salon_id: salonId },
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function getSurveyPreviewModel(salonId, bookedViaPortal, token) {
  const res = await axios.get(`${API}/marketing/surveys/preview-model`, {
    params: {
      salon_id: salonId,
      booked_via_portal: bookedViaPortal ? true : false,
    },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createSurveyPreviewLink(salonId, bookedViaPortal, token) {
  const res = await axios.post(
    `${API}/marketing/surveys/preview-link`,
    { booked_via_portal: !!bookedViaPortal },
    {
      params: { salon_id: salonId },
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function getSurveySatisfactionSummary(payload, token) {
  const res = await axios.post(
    `${API}/reports/client-satisfaction/summary`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function getSurveySatisfactionByStaff(payload, token) {
  const res = await axios.post(
    `${API}/reports/client-satisfaction/by-staff`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function getSurveySatisfactionTrends(payload, token) {
  const res = await axios.post(
    `${API}/reports/client-satisfaction/trends`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}
